import { z } from 'zod';
import * as t from 'Shared/model/basic';

export const price = z.object({
	price: z.string().optional(),
	description: z.string().optional()
});

//TODO split off wines etc...
export const menuItem = z.object({
	name: z.string(),	
	tagline: z.string(),   //XXX cf max 1000 chars
	moreInfo: z.string(),  //XXX cf max 20000 chars

	variety: z.string(),
	varietyOther: z.string(),
	year: z.number(), 		//XXX --> year()
	tags: z.array(z.string()), 
	region: z.string(),

//TODO replace with brandId??
//Brand related stuff:
	brandName: z.string(),		//XXX maybe just for beers, wines, etc
	state: z.string(),
	country: z.string(),

	//CJ not using extraFields yet, ben might have good ideas for it
//	['extraFields', { type: ['string', 100] }],

		//    ['addOns', { type: ['string', 200] }],
//		['priceOne', { type: ['price'] }],
//		['priceTwo', { type: ['price'] }],
//		['priceThree', { type: ['price'] }],
//		['priceFour', { type: ['price'] }],

//FIXME add prices in here...

	//CJ did get replace working so did a delete and appendTo to increase description string from 200-300

	description: z.string(),  //XXX max 2000

	imageSource: z.string(),	
	imageType: z.string(),   //TODO
	imageDimensions: z.string(),  //TODO

	image: t.image,
//FIXME replace square etc	

	prices: z.array(price),

//XXX suspect we dont REALLY want this here. Makes more sense at top menu level
	status: z.string(),		//TODO put options. NB used in events, specials too
	scheduleDate: t.dateTime
})
.partial().required({
	status: true
});
export type MenuItem = z.infer<typeof menuItem>;

//export const menuItems = z.array(menuItem);
export const section = z.array(menuItem);
export type Section = z.infer<typeof section>;

export const sections = z.record(z.array(menuItem));
export type Sections = z.infer<typeof sections>;

/* One standard style turned on for a menu, named by the category and type it sits under in
   siteTheme().styles - the same shape venue.settings and the page documents store their styles in.
   Chosen in the menu designer (see StyleTagContents), read by MenuPage via resolveStyleDetails(). */
export const menuStyleTag = z.object({
	category: z.string(),
	type:     z.string(),
	params:   z.record(z.string(), z.any()).optional(),
});
export type MenuStyleTag = z.infer<typeof menuStyleTag>;

export const menuDoc = z.object({
	_id: t.id(),
	siteId: t.id(),
	productType: z.string(),
	title: z.string().optional(),
	styles: z.array(menuStyleTag).optional(),
	sections: sections.optional()
});

export type MenuDoc = z.infer<typeof menuDoc>;


/*
	The style tag a menu carries to lay its items out as image cards. Without it a menu renders as a
	plain imageless list - the layout nearly every venue used. It sits in the menu document's own
	'styles' array, chosen in the menu designer, so layout is a per-menu choice rather than a
	venue-wide setting. The matching style entry is 'For specific pages > Menu image cards' in
	specificPageStyles.ts.
*/
export const menuImageCardsStyle = {category: 'For specific pages', type: 'Menu image cards'};

export function menuUsesImageCards(menu:{styles?:MenuStyleTag[]} | undefined): boolean
{
	return (menu?.styles ?? []).some(s =>
		s.category == menuImageCardsStyle.category && s.type == menuImageCardsStyle.type
	);
}

